module.exports = __webpack_public_path__ + "static/50import-aed5f4c50016c7d238508b114103a4f0.png";